namespace GeniuzPOS.PosShift {
    export enum Docfg {
        Tax = 1,
        CN = 2
    }
    Serenity.Decorators.registerEnumType(Docfg, 'GeniuzPOS.PosShift.Docfg');
}
